'use client';

import { useEffect } from 'react';

import type { FragmentType } from '@packages/gql/generated/shopping/fragment-masking';
import { unmask } from '@packages/gql/src/betterMasking';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type { GTMEventGlycerinDisplayCategory } from '@packages/tracking/src/types/events';
import type { UseDisplayCategoryTrackingFragmentFragmentDoc } from '@packages/gql/generated/shopping/UseDisplayCategoryTrackingFragmentFragmentDoc';

/* GraphQL */ `
  fragment UseDisplayCategoryTrackingFragment on ProperCategoryQueryResult {
    currentCategoryId
  }
`;

export type UseDisplayCategoryTrackingProps = {
  maskedResult: FragmentType<typeof UseDisplayCategoryTrackingFragmentFragmentDoc>;
};

const useDisplayCategoryTracking = ({ maskedResult }: UseDisplayCategoryTrackingProps) => {
  const { currentCategoryId: categoryId } =
    unmask<typeof UseDisplayCategoryTrackingFragmentFragmentDoc>(maskedResult);

  const dispatchGTMEvent = useTracking();

  useEffect(() => {
    dispatchGTMEvent<GTMEventGlycerinDisplayCategory>({
      event: 'DisplayCategory',
      DisplayCategoryData: {
        categoryId,
      },
    });
  }, [dispatchGTMEvent, categoryId]);
};

export const DisplayCategoryTracking = ({ maskedResult }: UseDisplayCategoryTrackingProps) => {
  useDisplayCategoryTracking({ maskedResult });

  return null;
};
